import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ada56856"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "List" }
const _hoisted_2 = {
  key: 0,
  class: "flex justify-end items-center mb-3"
}
const _hoisted_3 = {
  key: 1,
  class: "List__loader"
}
const _hoisted_4 = {
  key: 2,
  class: "List__empty"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-400" }, "Нет данных", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 3,
  class: "List__items"
}
const _hoisted_8 = {
  key: 0,
  class: "flex justify-end items-center gap-3 bg-white px-2 py-3"
}
const _hoisted_9 = {
  key: 4,
  class: "flex justify-end items-center mt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pagination = _resolveComponent("pagination")!
  const _component_loader = _resolveComponent("loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.pagination)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_pagination, {
            currentPage: _ctx.paginationCurrentPage,
            totalItems: _ctx.paginationTotalItems,
            totalPages: _ctx.paginationTotalPages,
            limit: _ctx.paginationLimit,
            onChange: _ctx.emitChangePage
          }, null, 8, ["currentPage", "totalItems", "totalPages", "limit", "onChange"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_loader, { class: "primary" })
        ]))
      : (_ctx.items.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_ctx.$slots['actions'])
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _renderSlot(_ctx.$slots, "actions", {}, undefined, true)
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "List__item",
                key: item
              }, [
                _renderSlot(_ctx.$slots, "item", {
                  item: item,
                  index: i
                }, undefined, true)
              ]))
            }), 128))
          ])),
    (_ctx.pagination)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(_component_pagination, {
            currentPage: _ctx.paginationCurrentPage,
            totalItems: _ctx.paginationTotalItems,
            totalPages: _ctx.paginationTotalPages,
            limit: _ctx.paginationLimit,
            onChange: _ctx.emitChangePage
          }, null, 8, ["currentPage", "totalItems", "totalPages", "limit", "onChange"])
        ]))
      : _createCommentVNode("", true)
  ]))
}